import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, params = {}) => {
  try {
    const { data } = await axios.get('service-automation', { params })

    if (data && data.automations) {
      commit('setRows', data.automations)
      return data.automations
    }

    commit('setRows', [])
    return []
  } catch (err) {
    console.error('Erro ao buscar automações de serviço:', err)
    commit('setRows', [])
    return []
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.post('service-automation', body)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const update = async (_, { id, body }) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.put(`service-automation/${id}`, body)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const remove = async (_, id) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.delete(`service-automation/${id}`)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

